
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[pageUrl]",
      function () {
        return require("private-next-pages/blog/[pageUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[pageUrl]"])
      });
    }
  